<template>
  <button
    :class="['button', color, size, { disabled: disabled }]"
    :disabled="disabled"
    v-bind="$attrs"
  >
    <slot name="icon"></slot>
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'UiButton',
  props: {
    color: {
      type: String,
      default: 'primary',
    },
    disabled: {
      type: [Boolean, String],
      default: false,
    },
    size: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
.button {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 14px;
  border: none;
  outline: none;
  cursor: pointer;
  text-decoration: none;
  color: rgba(255, 255, 255, 0.84);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.224px;
  border-radius: 10px;
  text-transform: none;
  transition: 0.3s;
  gap: 4px;

  &.xl {
    border-radius: 12px;
    padding: 16px;
    font-size: 18px;
    line-height: 24px;
  }

  &.primary {
    --bg: #f36355;
    background: var(--bg);
    border: 1px solid var(--bg);
    box-shadow: 2px 2px 10px 0 rgba(153, 153, 153, 0.2);
    color: rgba(255, 255, 255, 0.84);

    &.disabled {
      --bg: #f9b1aa !important;
      cursor: default;
      &:focus {
        box-shadow: unset;
      }
    }
    &:hover {
      --bg: #d6483d;
      color: #fcf3f3;
    }
    &:active {
      --bg: #b93f34;
      color: #fefefe;
    }
  }

  &.secondary {
    --bg: rgba(253, 201, 194, 0.25);
    background: var(--bg);
    border: 1px solid var(--bg);
    color: #d6483d;

    &:hover {
      --bg: #f89a8e40;
    }
  }

  &.outline {
    background: white;
    border-radius: 8px;
    border: 1px solid #d2d7db;
    color: #091620cc;
    padding: 12px;

    &:hover {
      border: 1px solid #adbac4;
    }

    &:active {
      border: 1px solid #8d9aa3;
    }
  }

  &.neutral {
    background: #3b6d9514;
    color: #091620cc;
  }

  &.small {
    font-weight: 500;
    font-size: 16px;
    line-height: 1.25;
    padding: 6px 16px;
  }

  &.medium {
    font-weight: 500;
    font-size: 14px;
    line-height: 1.1;
    padding: 10px 16px;
  }

  &.large {
    font-weight: 500;
    font-size: 16px;
    line-height: 1.25;
    letter-spacing: -1.4%;
    padding: 12px 20px;
    gap: 6px;
  }
}
</style>
